export default __webpack_public_path__ + "static/media/icon-angle-left.d53877df.svg";